import { useEffect } from "react";
import { useIsLoggedIn } from "@/features/auth/hooks/useIsLoggedIn";
import { useBetslipStore } from "@/features/betslip/stores/betslipStore";

export const useBetslipTab = () => {
  const isLoggedIn = useIsLoggedIn();
  const tab = useBetslipStore((s) => s.tab);
  const setTab = useBetslipStore((s) => s.setTab);

  useEffect(() => {
    if (!isLoggedIn && (tab === "pending" || tab === "settled")) {
      setTab("active");
    }
  }, [isLoggedIn, tab, setTab]);

  return [tab, setTab] as const;
};
